/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import useWindowDimensions from '../Utils/useWindowDimensions'

const DEFAULT_DRAWER_CONFIG = {
  isExpanded: true,
  isVisible: false,
  // isFullScreen will always start as false
}

const Menu = createContext()

function MenuProvider({ children }) {
  const current = window.location.pathname
  const [menu, setMenu] = useState(() => {
    const menuConfig = JSON.parse(
      localStorage.getItem('menu') || JSON.stringify(DEFAULT_DRAWER_CONFIG)
    )
    return {
      ...menuConfig,
      selectedItem: current,
       // Always start with fullscreen off
      isFullScreen: false,
    }
  })

  const toggleFullScreen = () => {
    setMenu((prev) => {
      const next = {
        ...prev,
        isFullScreen: !prev.isFullScreen,
      }
      // Only persist non-fullscreen properties
      const { isFullScreen, ...persistedConfig } = next
      localStorage.setItem('menu', JSON.stringify(persistedConfig))
      return next
    })
  }

  const windowSize = useWindowDimensions()
  useEffect(() => {
    if (windowSize.width <= 1200 && windowSize.width >= 760) {
      setMenu((prev) => {
        const next = {
          ...prev,
          isVisible: false,
        }
        const { isFullScreen, ...persistedConfig } = next
        localStorage.setItem('menu', JSON.stringify(persistedConfig))
        return next
      })
    }
  }, [windowSize])

  const toggleDrawer = () => {
    setMenu((prev) => {
      const next = {
        ...prev,
        isVisible: !prev.isVisible,
      }
      const { isFullScreen, ...persistedConfig } = next
      localStorage.setItem('menu', JSON.stringify(persistedConfig))
      return next
    })
  }

  const toggleDrawerExpansion = () => {
    setMenu((prev) => {
      const next = {
        ...prev,
        isExpanded: !prev.isExpanded,
      }
      const { isFullScreen, ...persistedConfig } = next
      localStorage.setItem('menu', JSON.stringify(persistedConfig))
      return next
    })
  }

  const toggleDrawerOnHelpCenterExpansion = () => {
    setMenu((prev) => {
      const next = {
        ...prev,
        isExpanded: true
      }
      const { isFullScreen, ...persistedConfig } = next
      localStorage.setItem('menu', JSON.stringify(persistedConfig))
      return next
    })
  }

  const setSelectedRoute = (selectedItem) => {
    setMenu((prev) => {
      const next = {
        ...prev,
        selectedItem,
      }
      const { isFullScreen, ...persistedConfig } = next
      localStorage.setItem('menu', JSON.stringify(persistedConfig))
      return next
    })
  }

  return (
    <Menu.Provider
      value={{
        ...menu,
        toggleFullScreen,
        toggleDrawer,
        toggleDrawerExpansion,
        toggleDrawerOnHelpCenterExpansion,
        setSelectedRoute,
      }}
    >
      {children}
    </Menu.Provider>
  )
}

MenuProvider.propTypes = {
  children: PropTypes.any,
}

function useMenu() {
  const context = useContext(Menu)
  if (context === undefined) {
    throw new Error('useMenu must be used within an MenuProvider')
  }
  return context
}

export { useMenu }
export default MenuProvider